var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageSharpThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 48V356.7L122.3 250.3l5.7-5.7 5.7 5.7L224 340.7 378.3 186.3l5.7-5.7 5.7 5.7L496 292.7V48H16zm0 331.3V464h84.7l112-112L128 267.3 16 379.3zm368-176L123.3 464H496V315.3l-112-112zM0 32H16 496h16V48 464v16H496 16 0V464 48 32zM168 160a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-96 0a56 56 0 1 1 112 0A56 56 0 1 1 72 160z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageSharpThin);
export default __webpack_public_path__ + "static/media/image-sharp-thin.7e66e9149881d5a7a9095346ac6d4e27.svg";
export { ForwardRef as ReactComponent };